import React from "react";

// Конфігурація кольорів дозволених статусів
const allowedStatuses = {
  "Оновити ВСЕ": "status-primary",
  Ігнорувати: "status-secondary",
  "Оновити НАЯВНІСТЬ": "status-third",
};

// Компонент відображення спадного меню оновлення статусу сторінки "Товари постачальників"
const ProductsUpdateStatusSelector = ({ article, currentStatus, onStatusUpdate }) => {
  // Функція для обробки зміни статусу
  const handleChange = (e) => {
    const newStatus = e.target.value;
    onStatusUpdate(article, newStatus);
  };

  return (
    <select
      value={currentStatus || ""}
      onChange={handleChange}
      className={`status-select ${allowedStatuses[currentStatus] || ""}`}
    >
      {Object.keys(allowedStatuses).map((status) => (
        <option key={status} value={status}>
          {status}
        </option>
      ))}
    </select>
  );
};

export default ProductsUpdateStatusSelector;
